import React from "react";
import {useFormik} from "formik";
import {OperationApiPut} from "./operation_api";
import * as yup from "yup";
import {Box, Button, CardActions, CardContent, FormControl, FormControlLabel, Switch, TextField} from "@mui/material";
import {TablesInsert} from "../../apitypes";


interface OperationFormProps {
    onSubmit: (values: TablesInsert<"workTask">) => void
    onCancel: () => void
    object: Omit<OperationApiPut, "id" | "created_at">,
    isUpdating: boolean,

}

const OperationSchema = yup.object().shape({
    Code: yup.string().min(2).max(40).required(),
    Name: yup.string().required(),
    Details: yup.string().required(),
    Active: yup.boolean().required(),
    NeedsWorkOrder: yup.boolean().required(),
    NeedsMachine: yup.boolean().required()
})

export default ({object, onSubmit, onCancel, isUpdating}: OperationFormProps) => {
    const formik = useFormik<typeof object>({
        initialValues: object,
        onSubmit: onSubmit,
        validationSchema: OperationSchema
    });

    return <Box component={"form"} className={"form-100"} onSubmit={formik.handleSubmit}>
        <CardContent>
            <TextField
                name={"Code"}
                id={"Code"}
                value={formik.values.Code}
                label={"Koda"}
                onBlur={formik.handleBlur}

                onChange={formik.handleChange}
                error={formik.touched.Code && Boolean(formik.errors.Code)}
                helperText={formik.touched.Code && formik.errors.Code}
            />
            <TextField
                name={"Name"}
                id={"Name"}
                value={formik.values.Name}
                label={"Ime za prikaz"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.Name && Boolean(formik.errors.Name)}
                helperText={formik.touched.Name && formik.errors.Name}
            />
            <TextField
                name={"Details"}
                id={"Details"}
                value={formik.values.Details}
                label={"Opis"}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                error={formik.touched.Details && Boolean(formik.errors.Details)}
                helperText={formik.touched.Details && formik.errors.Details}
            />
            <FormControl>
                <FormControlLabel label={"Potrebuje stroj"} control={<Switch
                    id={"NeedsMachine"}
                    name={"NeedsMachine"}
                    onChange={formik.handleChange}
                    checked={formik.values.NeedsMachine}
                />}/>
            </FormControl>
            <FormControl>
                <FormControlLabel label={"Potrebuje delovni nalog"} control={<Switch
                    id={"NeedsWorkOrder"}
                    name={"NeedsWorkOrder"}
                    onChange={formik.handleChange}
                    checked={formik.values.NeedsWorkOrder}
                />}/>
            </FormControl>
            <FormControl>
                <FormControlLabel label={"Aktivna"} control={<Switch
                    id={"Active"}
                    name={"Active"}
                    onChange={formik.handleChange}
                    checked={formik.values.Active}
                />}/>
            </FormControl>
        </CardContent>
        <CardActions>
            <Button disabled={isUpdating} type={"submit"}>Shrani</Button>
            <Button onClick={onCancel}>Prekliči</Button>
        </CardActions>
    </Box>

}
